/* eslint-disable */
/* global localStorage */
import Vue from 'vue'
import axios from 'axios'
const API_URL = (window.location.href.indexOf('localhost') >= 0) ? 'http://localhost:55567' : 'https://comsservices.ravenware.co.uk'

console.log('Working from :' + API_URL)
// Todo:- should be able to use webpack "process.env.API_URL" like >>  const API_URL = process.env.API_URL || 'https://trackwiseapi.ravenware.co.uk'
// alert(store.state.user.auth.token)
// add bearer to each request.
export default axios.create({
  baseURL: API_URL,
}

// export default axios.create({
//   baseURL: API_URL,
//   headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.umbriltoken}
// }
)
